import {
  AsyncResp,
  RequestParams,
  requestPapi,
} from '@paradigm/api/src/fetch-api';
import { getQueryString } from '@paradigm/api/src/internal/utils';
import {
  ListPositionsReq,
  ListPositionsResult,
  Position,
  RawPosition,
  processPosition,
} from '../entities/positions';

const BASE_URL = '/v1';

async function requestDrfqV2<T>(req: RequestParams): AsyncResp<T> {
  return requestPapi({
    ...req,
    url: `${BASE_URL}${req.url}`,
  });
}

export async function listPositions(
  req: ListPositionsReq,
): AsyncResp<ListPositionsResult<Position>> {
  const { cursor, pageSize, productCodes, venues, accounts, ...rest } = req;

  const query = getQueryString([
    ['cursor', cursor],
    ['page_size', pageSize],
    ['product_code', productCodes],
    ['account_name', accounts],
    ['venue', venues],
  ]);

  const resp = await requestDrfqV2<ListPositionsResult<RawPosition>>({
    ...rest,
    method: 'GET',
    url: `/positions${query}`,
  });

  if (!resp.ok) return resp;

  return {
    ...resp,
    data: {
      ...resp.data,
      last_updated_at: new Date(resp.data.last_updated_at),
      results: resp.data.results.map(processPosition),
    },
  };
}
